/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Message_HintInputs */

const en_contact_form_message_hint = /** @type {(inputs: Contact_Form_Message_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sentence about the task is enough.`)
};

const lv_contact_form_message_hint = /** @type {(inputs: Contact_Form_Message_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pietiek ar vienu teikumu par darbu.`)
};

/**
* | output |
* | --- |
* | "A sentence about the task is enough." |
*
* @param {Contact_Form_Message_HintInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_message_hint = /** @type {((inputs?: Contact_Form_Message_HintInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Message_HintInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_message_hint(inputs)
	return en_contact_form_message_hint(inputs)
});